/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Recap
 * OpenAPI spec version: 1
 */
import * as zod from 'zod';

import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import { useApiFetch } from '../client.ts';
import type { ErrorType } from '../client.ts';
import { useMutationBehavior } from '../mutations.ts';
import { useQueryBehavior } from '../queries.ts';
import { Invitation, InvitationPreview, Membership, PendingInvitation, Workspace } from './schemas.ts';
import type {
    EmailAddressUpdate,
    ErrorResponse,
    InvitationInput,
    MembershipUpdate,
    UploadWorkspaceLogoBody,
    WorkspaceCreateInput,
    WorkspaceInput,
} from './schemas.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getListWorkspacesUrl = () => {
    return `/workspaces`;
};

/**
 * @summary List Workspaces
 */
export const useListWorkspacesHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Workspace[]>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListWorkspacesUrl(), {
            ...options,
            method: 'GET',

            schema: zod.array(Workspace),
        });
    };
};

export const getListWorkspacesQueryKey = () => {
    return ['workspaces'] as const;
};

export const useListWorkspacesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListWorkspacesQueryKey();

    const listWorkspaces = useListWorkspacesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>> = ({ signal }) =>
        listWorkspaces({ signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        {},
        { url: `/workspaces`, operationId: 'list_workspaces', operationName: 'listWorkspaces' }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListWorkspacesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>>;
export type ListWorkspacesQueryError = ErrorType<ErrorResponse>;

export function useListWorkspaces<
    TData = Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWorkspaces<
    TData = Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListWorkspaces<
    TData = Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Workspaces
 */

export function useListWorkspaces<
    TData = Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListWorkspacesHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListWorkspacesQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateWorkspaceUrl = () => {
    return `/workspaces`;
};

/**
 * @summary Create Workspace
 */
export const useCreateWorkspaceHook = (): ((
    workspaceCreateInput: WorkspaceCreateInput,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Workspace>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (workspaceCreateInput: WorkspaceCreateInput, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getCreateWorkspaceUrl(), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(workspaceCreateInput),
            schema: Workspace,
        });
    };
};

export const getCreateWorkspaceMutationKey = () => ['createWorkspace'] as const;

export const useCreateWorkspaceMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateWorkspaceHook>>>,
        TError,
        CreateWorkspaceMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateWorkspaceHook>>>,
    TError,
    CreateWorkspaceMutationVariables,
    TContext
> => {
    const mutationKey = getCreateWorkspaceMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const createWorkspace = useCreateWorkspaceHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateWorkspaceHook>>>,
        CreateWorkspaceMutationVariables
    > = (props) => {
        const { data } = props ?? {};

        return createWorkspace(data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspaces` },
        { operationId: 'create_workspace', operationName: 'createWorkspace' }
    );

    return customOptions;
};

export type CreateWorkspaceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateWorkspaceHook>>>>;
export type CreateWorkspaceMutationBody = WorkspaceCreateInput;
export type CreateWorkspaceMutationError = ErrorType<ErrorResponse>;
export type CreateWorkspaceMutationVariables = { data: WorkspaceCreateInput };

/**
 * @summary Create Workspace
 */
export const useCreateWorkspace = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCreateWorkspaceHook>>>,
            TError,
            CreateWorkspaceMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateWorkspaceHook>>>,
    TError,
    CreateWorkspaceMutationVariables,
    TContext
> => {
    return useMutation(useCreateWorkspaceMutationOptions(options), queryClient);
};
export const getUpdateWorkspaceUrl = (workspaceId: string) => {
    return `/workspaces/${workspaceId}`;
};

/**
 * @summary Update Workspace
 */
export const useUpdateWorkspaceHook = (): ((
    workspaceId: string,
    workspaceInput: WorkspaceInput,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Workspace>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (
        workspaceId: string,
        workspaceInput: WorkspaceInput,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getUpdateWorkspaceUrl(workspaceId), {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(workspaceInput),
            schema: Workspace,
        });
    };
};

export const getUpdateWorkspaceMutationKey = () => ['updateWorkspace'] as const;

export const useUpdateWorkspaceMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceHook>>>,
        TError,
        UpdateWorkspaceMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceHook>>>,
    TError,
    UpdateWorkspaceMutationVariables,
    TContext
> => {
    const mutationKey = getUpdateWorkspaceMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const updateWorkspace = useUpdateWorkspaceHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceHook>>>,
        UpdateWorkspaceMutationVariables
    > = (props) => {
        const { workspaceId, data } = props ?? {};

        return updateWorkspace(workspaceId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspaces/{workspaceId}` },
        { operationId: 'update_workspace', operationName: 'updateWorkspace' }
    );

    return customOptions;
};

export type UpdateWorkspaceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceHook>>>>;
export type UpdateWorkspaceMutationBody = WorkspaceInput;
export type UpdateWorkspaceMutationError = ErrorType<ErrorResponse>;
export type UpdateWorkspaceMutationVariables = { workspaceId: string; data: WorkspaceInput };

/**
 * @summary Update Workspace
 */
export const useUpdateWorkspace = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceHook>>>,
            TError,
            UpdateWorkspaceMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceHook>>>,
    TError,
    UpdateWorkspaceMutationVariables,
    TContext
> => {
    return useMutation(useUpdateWorkspaceMutationOptions(options), queryClient);
};
export const getDeleteWorkspaceUrl = (workspaceId: string) => {
    return `/workspaces/${workspaceId}`;
};

/**
 * @summary Delete Workspace
 */
export const useDeleteWorkspaceHook = (): ((
    workspaceId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (workspaceId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getDeleteWorkspaceUrl(workspaceId), {
            ...options,
            method: 'DELETE',
        });
    };
};

export const getDeleteWorkspaceMutationKey = () => ['deleteWorkspace'] as const;

export const useDeleteWorkspaceMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceHook>>>,
        TError,
        DeleteWorkspaceMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceHook>>>,
    TError,
    DeleteWorkspaceMutationVariables,
    TContext
> => {
    const mutationKey = getDeleteWorkspaceMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const deleteWorkspace = useDeleteWorkspaceHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceHook>>>,
        DeleteWorkspaceMutationVariables
    > = (props) => {
        const { workspaceId } = props ?? {};

        return deleteWorkspace(workspaceId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspaces/{workspaceId}` },
        { operationId: 'delete_workspace', operationName: 'deleteWorkspace' }
    );

    return customOptions;
};

export type DeleteWorkspaceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceHook>>>>;

export type DeleteWorkspaceMutationError = ErrorType<ErrorResponse>;
export type DeleteWorkspaceMutationVariables = { workspaceId: string };

/**
 * @summary Delete Workspace
 */
export const useDeleteWorkspace = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceHook>>>,
            TError,
            DeleteWorkspaceMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceHook>>>,
    TError,
    DeleteWorkspaceMutationVariables,
    TContext
> => {
    return useMutation(useDeleteWorkspaceMutationOptions(options), queryClient);
};
export const getUploadWorkspaceLogoUrl = () => {
    return `/workspace/logo`;
};

/**
 * @summary Upload Workspace Logo
 */
export const useUploadWorkspaceLogoHook = (): ((
    uploadWorkspaceLogoBody: UploadWorkspaceLogoBody,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Workspace>) => {
    const customFetcher = useApiFetch();
    return (
        uploadWorkspaceLogoBody: UploadWorkspaceLogoBody,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        const formData = new FormData();
        formData.append(`file`, uploadWorkspaceLogoBody.file);

        return customFetcher(getUploadWorkspaceLogoUrl(), {
            ...options,
            method: 'POST',
            body: formData,
            schema: Workspace,
        });
    };
};

export const getUploadWorkspaceLogoMutationKey = () => ['uploadWorkspaceLogo'] as const;

export const useUploadWorkspaceLogoMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUploadWorkspaceLogoHook>>>,
        TError,
        UploadWorkspaceLogoMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUploadWorkspaceLogoHook>>>,
    TError,
    UploadWorkspaceLogoMutationVariables,
    TContext
> => {
    const mutationKey = getUploadWorkspaceLogoMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const uploadWorkspaceLogo = useUploadWorkspaceLogoHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUploadWorkspaceLogoHook>>>,
        UploadWorkspaceLogoMutationVariables
    > = (props) => {
        const { data } = props ?? {};

        return uploadWorkspaceLogo(data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/logo` },
        { operationId: 'upload_workspace_logo', operationName: 'uploadWorkspaceLogo' }
    );

    return customOptions;
};

export type UploadWorkspaceLogoMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUploadWorkspaceLogoHook>>>
>;
export type UploadWorkspaceLogoMutationBody = UploadWorkspaceLogoBody;
export type UploadWorkspaceLogoMutationError = ErrorType<ErrorResponse>;
export type UploadWorkspaceLogoMutationVariables = { data: UploadWorkspaceLogoBody };

/**
 * @summary Upload Workspace Logo
 */
export const useUploadWorkspaceLogo = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUploadWorkspaceLogoHook>>>,
            TError,
            UploadWorkspaceLogoMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUploadWorkspaceLogoHook>>>,
    TError,
    UploadWorkspaceLogoMutationVariables,
    TContext
> => {
    return useMutation(useUploadWorkspaceLogoMutationOptions(options), queryClient);
};
export const getDeleteWorkspaceLogoUrl = () => {
    return `/workspace/logo`;
};

/**
 * @summary Delete Workspace Logo
 */
export const useDeleteWorkspaceLogoHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Workspace>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getDeleteWorkspaceLogoUrl(), {
            ...options,
            method: 'DELETE',

            schema: Workspace,
        });
    };
};

export const getDeleteWorkspaceLogoMutationKey = () => ['deleteWorkspaceLogo'] as const;

export const useDeleteWorkspaceLogoMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceLogoHook>>>,
        TError,
        void,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceLogoHook>>>, TError, void, TContext> => {
    const mutationKey = getDeleteWorkspaceLogoMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const deleteWorkspaceLogo = useDeleteWorkspaceLogoHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceLogoHook>>>,
        void
    > = () => {
        return deleteWorkspaceLogo(requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/logo` },
        { operationId: 'delete_workspace_logo', operationName: 'deleteWorkspaceLogo' }
    );

    return customOptions;
};

export type DeleteWorkspaceLogoMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceLogoHook>>>
>;

export type DeleteWorkspaceLogoMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete Workspace Logo
 */
export const useDeleteWorkspaceLogo = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceLogoHook>>>,
            TError,
            void,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useDeleteWorkspaceLogoHook>>>, TError, void, TContext> => {
    return useMutation(useDeleteWorkspaceLogoMutationOptions(options), queryClient);
};
export const getGetWorkspaceLogoUrl = () => {
    return `/workspace/logo`;
};

/**
 * @summary Get Workspace Logo
 */
export const useGetWorkspaceLogoHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getGetWorkspaceLogoUrl(), {
            ...options,
            method: 'GET',
        });
    };
};

export const getGetWorkspaceLogoQueryKey = () => {
    return ['workspace', 'logo'] as const;
};

export const useGetWorkspaceLogoQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>,
    TError = ErrorType<ErrorResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetWorkspaceLogoQueryKey();

    const getWorkspaceLogo = useGetWorkspaceLogoHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>> = ({ signal }) =>
        getWorkspaceLogo({ signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        {},
        { url: `/workspace/logo`, operationId: 'get_workspace_logo', operationName: 'getWorkspaceLogo' }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWorkspaceLogoQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>>;
export type GetWorkspaceLogoQueryError = ErrorType<ErrorResponse>;

export function useGetWorkspaceLogo<
    TData = Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkspaceLogo<
    TData = Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetWorkspaceLogo<
    TData = Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Workspace Logo
 */

export function useGetWorkspaceLogo<
    TData = Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWorkspaceLogoHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useGetWorkspaceLogoQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getRenewWorkspaceEmailAddressUrl = () => {
    return `/workspace/email-address`;
};

/**
 * @summary Renew Workspace Email Address
 */
export const useRenewWorkspaceEmailAddressHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Workspace>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getRenewWorkspaceEmailAddressUrl(), {
            ...options,
            method: 'POST',

            schema: Workspace,
        });
    };
};

export const getRenewWorkspaceEmailAddressMutationKey = () => ['renewWorkspaceEmailAddress'] as const;

export const useRenewWorkspaceEmailAddressMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useRenewWorkspaceEmailAddressHook>>>,
        TError,
        void,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRenewWorkspaceEmailAddressHook>>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = getRenewWorkspaceEmailAddressMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const renewWorkspaceEmailAddress = useRenewWorkspaceEmailAddressHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useRenewWorkspaceEmailAddressHook>>>,
        void
    > = () => {
        return renewWorkspaceEmailAddress(requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/email-address` },
        { operationId: 'renew_workspace_email_address', operationName: 'renewWorkspaceEmailAddress' }
    );

    return customOptions;
};

export type RenewWorkspaceEmailAddressMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useRenewWorkspaceEmailAddressHook>>>
>;

export type RenewWorkspaceEmailAddressMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Renew Workspace Email Address
 */
export const useRenewWorkspaceEmailAddress = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useRenewWorkspaceEmailAddressHook>>>,
            TError,
            void,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useRenewWorkspaceEmailAddressHook>>>,
    TError,
    void,
    TContext
> => {
    return useMutation(useRenewWorkspaceEmailAddressMutationOptions(options), queryClient);
};
export const getUpdateWorkspaceEmailAddressUrl = () => {
    return `/workspace/email-address`;
};

/**
 * @summary Update Workspace Email Address
 */
export const useUpdateWorkspaceEmailAddressHook = (): ((
    emailAddressUpdate: EmailAddressUpdate,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Workspace>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (emailAddressUpdate: EmailAddressUpdate, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getUpdateWorkspaceEmailAddressUrl(), {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(emailAddressUpdate),
            schema: Workspace,
        });
    };
};

export const getUpdateWorkspaceEmailAddressMutationKey = () => ['updateWorkspaceEmailAddress'] as const;

export const useUpdateWorkspaceEmailAddressMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceEmailAddressHook>>>,
        TError,
        UpdateWorkspaceEmailAddressMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceEmailAddressHook>>>,
    TError,
    UpdateWorkspaceEmailAddressMutationVariables,
    TContext
> => {
    const mutationKey = getUpdateWorkspaceEmailAddressMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const updateWorkspaceEmailAddress = useUpdateWorkspaceEmailAddressHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceEmailAddressHook>>>,
        UpdateWorkspaceEmailAddressMutationVariables
    > = (props) => {
        const { data } = props ?? {};

        return updateWorkspaceEmailAddress(data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/email-address` },
        { operationId: 'update_workspace_email_address', operationName: 'updateWorkspaceEmailAddress' }
    );

    return customOptions;
};

export type UpdateWorkspaceEmailAddressMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceEmailAddressHook>>>
>;
export type UpdateWorkspaceEmailAddressMutationBody = EmailAddressUpdate;
export type UpdateWorkspaceEmailAddressMutationError = ErrorType<ErrorResponse>;
export type UpdateWorkspaceEmailAddressMutationVariables = { data: EmailAddressUpdate };

/**
 * @summary Update Workspace Email Address
 */
export const useUpdateWorkspaceEmailAddress = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceEmailAddressHook>>>,
            TError,
            UpdateWorkspaceEmailAddressMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateWorkspaceEmailAddressHook>>>,
    TError,
    UpdateWorkspaceEmailAddressMutationVariables,
    TContext
> => {
    return useMutation(useUpdateWorkspaceEmailAddressMutationOptions(options), queryClient);
};
export const getGetInvitationPreviewUrl = (token: string | null) => {
    return `/invitations/${token}`;
};

/**
 * @summary Get Invitation Preview
 */
export const useGetInvitationPreviewHook = (): ((
    token: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<InvitationPreview>) => {
    const customFetcher = useApiFetch();
    return (token: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getGetInvitationPreviewUrl(token), {
            ...options,
            method: 'GET',

            schema: InvitationPreview,
        });
    };
};

export const getGetInvitationPreviewQueryKey = (token: string | null) => {
    return ['invitations', token] as const;
};

export const useGetInvitationPreviewQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    token: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetInvitationPreviewQueryKey(token);

    const getInvitationPreview = useGetInvitationPreviewHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>> = ({ signal }) =>
        getInvitationPreview(token, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions },
        { token },
        { url: `/invitations/${token}`, operationId: 'get_invitation_preview', operationName: 'getInvitationPreview' }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInvitationPreviewQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>
>;
export type GetInvitationPreviewQueryError = ErrorType<ErrorResponse>;

export function useGetInvitationPreview<
    TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    token: string | null,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetInvitationPreview<
    TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    token: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetInvitationPreview<
    TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    token: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Invitation Preview
 */

export function useGetInvitationPreview<
    TData = Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    token: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInvitationPreviewHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useGetInvitationPreviewQueryOptions(token, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListMyInvitationsUrl = () => {
    return `/me/invitations`;
};

/**
 * @summary List My Invitations
 */
export const useListMyInvitationsHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<PendingInvitation[]>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListMyInvitationsUrl(), {
            ...options,
            method: 'GET',

            schema: zod.array(PendingInvitation),
        });
    };
};

export const getListMyInvitationsQueryKey = () => {
    return ['me', 'invitations'] as const;
};

export const useListMyInvitationsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListMyInvitationsQueryKey();

    const listMyInvitations = useListMyInvitationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>> = ({ signal }) =>
        listMyInvitations({ signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        {},
        { url: `/me/invitations`, operationId: 'list_my_invitations', operationName: 'listMyInvitations' }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMyInvitationsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>
>;
export type ListMyInvitationsQueryError = ErrorType<ErrorResponse>;

export function useListMyInvitations<
    TData = Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyInvitations<
    TData = Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMyInvitations<
    TData = Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List My Invitations
 */

export function useListMyInvitations<
    TData = Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMyInvitationsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListMyInvitationsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAcceptInvitationUrl = (token: string) => {
    return `/invitations/${token}/accept`;
};

/**
 * @summary Accept Invitation
 */
export const useAcceptInvitationHook = (): ((
    token: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Workspace>) => {
    const customFetcher = useApiFetch();
    return (token: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getAcceptInvitationUrl(token), {
            ...options,
            method: 'POST',

            schema: Workspace,
        });
    };
};

export const getAcceptInvitationMutationKey = () => ['acceptInvitation'] as const;

export const useAcceptInvitationMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAcceptInvitationHook>>>,
        TError,
        AcceptInvitationMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAcceptInvitationHook>>>,
    TError,
    AcceptInvitationMutationVariables,
    TContext
> => {
    const mutationKey = getAcceptInvitationMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const acceptInvitation = useAcceptInvitationHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAcceptInvitationHook>>>,
        AcceptInvitationMutationVariables
    > = (props) => {
        const { token } = props ?? {};

        return acceptInvitation(token, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/invitations/{token}/accept` },
        { operationId: 'accept_invitation', operationName: 'acceptInvitation' }
    );

    return customOptions;
};

export type AcceptInvitationMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAcceptInvitationHook>>>
>;

export type AcceptInvitationMutationError = ErrorType<ErrorResponse>;
export type AcceptInvitationMutationVariables = { token: string };

/**
 * @summary Accept Invitation
 */
export const useAcceptInvitation = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useAcceptInvitationHook>>>,
            TError,
            AcceptInvitationMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAcceptInvitationHook>>>,
    TError,
    AcceptInvitationMutationVariables,
    TContext
> => {
    return useMutation(useAcceptInvitationMutationOptions(options), queryClient);
};
export const getListMembersUrl = () => {
    return `/workspace/members`;
};

/**
 * @summary List Members
 */
export const useListMembersHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Membership[]>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListMembersUrl(), {
            ...options,
            method: 'GET',

            schema: zod.array(Membership),
        });
    };
};

export const getListMembersQueryKey = () => {
    return ['workspace', 'members'] as const;
};

export const useListMembersQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListMembersQueryKey();

    const listMembers = useListMembersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>> = ({ signal }) =>
        listMembers({ signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        {},
        { url: `/workspace/members`, operationId: 'list_members', operationName: 'listMembers' }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMembersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>>;
export type ListMembersQueryError = ErrorType<ErrorResponse>;

export function useListMembers<
    TData = Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMembers<
    TData = Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMembers<
    TData = Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Members
 */

export function useListMembers<
    TData = Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMembersHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListMembersQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateMemberUrl = (membershipId: string) => {
    return `/workspace/members/${membershipId}`;
};

/**
 * @summary Update Member
 */
export const useUpdateMemberHook = (): ((
    membershipId: string,
    membershipUpdate: MembershipUpdate,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Membership>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (
        membershipId: string,
        membershipUpdate: MembershipUpdate,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getUpdateMemberUrl(membershipId), {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(membershipUpdate),
            schema: Membership,
        });
    };
};

export const getUpdateMemberMutationKey = () => ['updateMember'] as const;

export const useUpdateMemberMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateMemberHook>>>,
        TError,
        UpdateMemberMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateMemberHook>>>,
    TError,
    UpdateMemberMutationVariables,
    TContext
> => {
    const mutationKey = getUpdateMemberMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const updateMember = useUpdateMemberHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateMemberHook>>>,
        UpdateMemberMutationVariables
    > = (props) => {
        const { membershipId, data } = props ?? {};

        return updateMember(membershipId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/members/{membershipId}` },
        { operationId: 'update_member', operationName: 'updateMember' }
    );

    return customOptions;
};

export type UpdateMemberMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateMemberHook>>>>;
export type UpdateMemberMutationBody = MembershipUpdate;
export type UpdateMemberMutationError = ErrorType<ErrorResponse>;
export type UpdateMemberMutationVariables = { membershipId: string; data: MembershipUpdate };

/**
 * @summary Update Member
 */
export const useUpdateMember = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateMemberHook>>>,
            TError,
            UpdateMemberMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateMemberHook>>>,
    TError,
    UpdateMemberMutationVariables,
    TContext
> => {
    return useMutation(useUpdateMemberMutationOptions(options), queryClient);
};
export const getRemoveMemberUrl = (membershipId: string) => {
    return `/workspace/members/${membershipId}`;
};

/**
 * @summary Remove Member
 */
export const useRemoveMemberHook = (): ((
    membershipId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (membershipId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getRemoveMemberUrl(membershipId), {
            ...options,
            method: 'DELETE',
        });
    };
};

export const getRemoveMemberMutationKey = () => ['removeMember'] as const;

export const useRemoveMemberMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useRemoveMemberHook>>>,
        TError,
        RemoveMemberMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRemoveMemberHook>>>,
    TError,
    RemoveMemberMutationVariables,
    TContext
> => {
    const mutationKey = getRemoveMemberMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const removeMember = useRemoveMemberHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useRemoveMemberHook>>>,
        RemoveMemberMutationVariables
    > = (props) => {
        const { membershipId } = props ?? {};

        return removeMember(membershipId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/members/{membershipId}` },
        { operationId: 'remove_member', operationName: 'removeMember' }
    );

    return customOptions;
};

export type RemoveMemberMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRemoveMemberHook>>>>;

export type RemoveMemberMutationError = ErrorType<ErrorResponse>;
export type RemoveMemberMutationVariables = { membershipId: string };

/**
 * @summary Remove Member
 */
export const useRemoveMember = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useRemoveMemberHook>>>,
            TError,
            RemoveMemberMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useRemoveMemberHook>>>,
    TError,
    RemoveMemberMutationVariables,
    TContext
> => {
    return useMutation(useRemoveMemberMutationOptions(options), queryClient);
};
export const getLeaveWorkspaceUrl = () => {
    return `/workspace/members/me`;
};

/**
 * @summary Leave Workspace
 */
export const useLeaveWorkspaceHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getLeaveWorkspaceUrl(), {
            ...options,
            method: 'DELETE',
        });
    };
};

export const getLeaveWorkspaceMutationKey = () => ['leaveWorkspace'] as const;

export const useLeaveWorkspaceMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useLeaveWorkspaceHook>>>,
        TError,
        void,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useLeaveWorkspaceHook>>>, TError, void, TContext> => {
    const mutationKey = getLeaveWorkspaceMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const leaveWorkspace = useLeaveWorkspaceHook();

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useLeaveWorkspaceHook>>>, void> = () => {
        return leaveWorkspace(requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/members/me` },
        { operationId: 'leave_workspace', operationName: 'leaveWorkspace' }
    );

    return customOptions;
};

export type LeaveWorkspaceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLeaveWorkspaceHook>>>>;

export type LeaveWorkspaceMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Leave Workspace
 */
export const useLeaveWorkspace = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useLeaveWorkspaceHook>>>,
            TError,
            void,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useLeaveWorkspaceHook>>>, TError, void, TContext> => {
    return useMutation(useLeaveWorkspaceMutationOptions(options), queryClient);
};
export const getListInvitationsUrl = () => {
    return `/workspace/invitations`;
};

/**
 * @summary List Invitations
 */
export const useListInvitationsHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Invitation[]>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListInvitationsUrl(), {
            ...options,
            method: 'GET',

            schema: zod.array(Invitation),
        });
    };
};

export const getListInvitationsQueryKey = () => {
    return ['workspace', 'invitations'] as const;
};

export const useListInvitationsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListInvitationsQueryKey();

    const listInvitations = useListInvitationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>> = ({ signal }) =>
        listInvitations({ signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        {},
        { url: `/workspace/invitations`, operationId: 'list_invitations', operationName: 'listInvitations' }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListInvitationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>>;
export type ListInvitationsQueryError = ErrorType<ErrorResponse>;

export function useListInvitations<
    TData = Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListInvitations<
    TData = Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListInvitations<
    TData = Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Invitations
 */

export function useListInvitations<
    TData = Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListInvitationsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListInvitationsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateInvitationUrl = () => {
    return `/workspace/invitations`;
};

/**
 * @summary Create Invitation
 */
export const useCreateInvitationHook = (): ((
    invitationInput: InvitationInput,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Invitation>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (invitationInput: InvitationInput, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getCreateInvitationUrl(), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(invitationInput),
            schema: Invitation,
        });
    };
};

export const getCreateInvitationMutationKey = () => ['createInvitation'] as const;

export const useCreateInvitationMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>,
        TError,
        CreateInvitationMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>,
    TError,
    CreateInvitationMutationVariables,
    TContext
> => {
    const mutationKey = getCreateInvitationMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const createInvitation = useCreateInvitationHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>,
        CreateInvitationMutationVariables
    > = (props) => {
        const { data } = props ?? {};

        return createInvitation(data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/invitations` },
        { operationId: 'create_invitation', operationName: 'createInvitation' }
    );

    return customOptions;
};

export type CreateInvitationMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>
>;
export type CreateInvitationMutationBody = InvitationInput;
export type CreateInvitationMutationError = ErrorType<ErrorResponse>;
export type CreateInvitationMutationVariables = { data: InvitationInput };

/**
 * @summary Create Invitation
 */
export const useCreateInvitation = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>,
            TError,
            CreateInvitationMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateInvitationHook>>>,
    TError,
    CreateInvitationMutationVariables,
    TContext
> => {
    return useMutation(useCreateInvitationMutationOptions(options), queryClient);
};
export const getSendInvitationAgainUrl = (invitationId: string) => {
    return `/workspace/invitations/${invitationId}/send`;
};

/**
 * @summary Send Invitation Again
 */
export const useSendInvitationAgainHook = (): ((
    invitationId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (invitationId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getSendInvitationAgainUrl(invitationId), {
            ...options,
            method: 'POST',
        });
    };
};

export const getSendInvitationAgainMutationKey = () => ['sendInvitationAgain'] as const;

export const useSendInvitationAgainMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSendInvitationAgainHook>>>,
        TError,
        SendInvitationAgainMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSendInvitationAgainHook>>>,
    TError,
    SendInvitationAgainMutationVariables,
    TContext
> => {
    const mutationKey = getSendInvitationAgainMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const sendInvitationAgain = useSendInvitationAgainHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSendInvitationAgainHook>>>,
        SendInvitationAgainMutationVariables
    > = (props) => {
        const { invitationId } = props ?? {};

        return sendInvitationAgain(invitationId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/invitations/{invitationId}/send` },
        { operationId: 'send_invitation_again', operationName: 'sendInvitationAgain' }
    );

    return customOptions;
};

export type SendInvitationAgainMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useSendInvitationAgainHook>>>
>;

export type SendInvitationAgainMutationError = ErrorType<ErrorResponse>;
export type SendInvitationAgainMutationVariables = { invitationId: string };

/**
 * @summary Send Invitation Again
 */
export const useSendInvitationAgain = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useSendInvitationAgainHook>>>,
            TError,
            SendInvitationAgainMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useSendInvitationAgainHook>>>,
    TError,
    SendInvitationAgainMutationVariables,
    TContext
> => {
    return useMutation(useSendInvitationAgainMutationOptions(options), queryClient);
};
export const getDeleteInvitationUrl = (invitationId: string) => {
    return `/workspace/invitations/${invitationId}`;
};

/**
 * @summary Delete Invitation
 */
export const useDeleteInvitationHook = (): ((
    invitationId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (invitationId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getDeleteInvitationUrl(invitationId), {
            ...options,
            method: 'DELETE',
        });
    };
};

export const getDeleteInvitationMutationKey = () => ['deleteInvitation'] as const;

export const useDeleteInvitationMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteInvitationHook>>>,
        TError,
        DeleteInvitationMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteInvitationHook>>>,
    TError,
    DeleteInvitationMutationVariables,
    TContext
> => {
    const mutationKey = getDeleteInvitationMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const deleteInvitation = useDeleteInvitationHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteInvitationHook>>>,
        DeleteInvitationMutationVariables
    > = (props) => {
        const { invitationId } = props ?? {};

        return deleteInvitation(invitationId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/invitations/{invitationId}` },
        { operationId: 'delete_invitation', operationName: 'deleteInvitation' }
    );

    return customOptions;
};

export type DeleteInvitationMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteInvitationHook>>>
>;

export type DeleteInvitationMutationError = ErrorType<ErrorResponse>;
export type DeleteInvitationMutationVariables = { invitationId: string };

/**
 * @summary Delete Invitation
 */
export const useDeleteInvitation = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeleteInvitationHook>>>,
            TError,
            DeleteInvitationMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteInvitationHook>>>,
    TError,
    DeleteInvitationMutationVariables,
    TContext
> => {
    return useMutation(useDeleteInvitationMutationOptions(options), queryClient);
};
